import React, { useState, useEffect, useRef } from "react";
import {
  Grid,
  TextField,
  Button,
  Switch,
  Box,
  FormControlLabel,
  Tabs,
  Tab,
  Paper,
  Autocomplete,
} from "@mui/material";
import { notification } from "antd";
import DocumentosDeUsuario from "./DocumentosDeUsuario";
import { actualizarUsuario, crearUsuario } from "../services/usuarios.service";
import Loader from "./Loader";
import { obtenerOficinas } from "../services/oficinas.service";

const UsuariosForm = ({
  setIsVisibleModal,
  reload,
  onlyDocuments,
  setReload,
  usuarioExistente,
}) => {
  const [userData, setUserData] = useState({});
  const inputRef = useRef(null);
  const autocompleteRef = useRef(null);
  const [tabIndex, setTabIndex] = useState(onlyDocuments? 1: 0);
  const [loadingUsuario, setLoadingUsuario] = useState(true);
  const [oficinasList, setOficinasList] = useState([]);
  const [oficinasSeleccionadas, setOficinasSeleccionadas] = useState([]);

  const handleTabChange = (event, newValue) => {
    setTabIndex(newValue);
  };

  const fetchOficinas = async () => {
    try {
      const oficinasList = await obtenerOficinas();

      if (oficinasList?.data?.length > 0) {
        console.log("oficinas list", oficinasList.data);

        setOficinasList(oficinasList.data);
      }
    } catch (error) {
      console.log("error al obtener oficinas", error);
    }
  };

  const rellenarCampos = (usuarioExistente) => {
    console.log("rellenar campos, ", usuarioExistente);
    setUserData({
      id_usuario: usuarioExistente?.id_usuario || "",
      nombre: usuarioExistente?.nombre || "",
      mail: usuarioExistente?.mail || "",
      id_tipo_us: usuarioExistente?.id_tipo_us || "",
      ext_cuit: usuarioExistente?.ext_cuit || "",
      ext_razon_social: usuarioExistente?.ext_razon_social || "",
      ext_email: usuarioExistente?.ext_email || "",
      ext_telefono: usuarioExistente?.ext_telefono || "",
      ext_profesion: usuarioExistente?.ext_profesion || "",
      ext_matricula: usuarioExistente?.ext_matricula || "",
      ext_domicilio: usuarioExistente?.ext_domicilio || "",
      ext_localidad: usuarioExistente?.ext_localidad || "",
      ext_provincia: usuarioExistente?.ext_provincia || "",
      ext_homologado: usuarioExistente?.ext_homologado === "1" ? true : false,
      nro_prof: usuarioExistente?.nro_prof || "",
    });

    if (usuarioExistente.oficinas.length > 0 && oficinasList.length > 0) {
      console.log("oficinas list", oficinasList);
      const oficinasActivas = oficinasList.filter((oficina) =>
        usuarioExistente.oficinas.some(
          (usuarioOficina) => usuarioOficina === oficina.id
        )
      );

      console.log("Oficinas activas seleccionadas:", oficinasActivas);
      setOficinasSeleccionadas(oficinasActivas);
    } else {
      setOficinasSeleccionadas([]);
    }
  };

  useEffect(() => {
    fetchOficinas();
  }, []);

  useEffect(() => {
    try {
      if (usuarioExistente) {
        rellenarCampos(usuarioExistente);
      } else {
        setUserData({
          id_usuario: "",
          nombre: "",
          mail: "",
          id_tipo_us: 0,
          ext_cuit: "",
          ext_razon_social: "",
          ext_email: "",
          ext_telefono: "",
          ext_profesion: "",
          ext_matricula: "",
          ext_domicilio: "",
          ext_localidad: "",
          ext_provincia: "",
          ext_homologado: false,
          nro_prof: "",
        });
        setOficinasSeleccionadas([]);
      }
    } catch (error) {
      console.log("error", error);
    } finally {
      setLoadingUsuario(false);
    }
  }, [usuarioExistente, oficinasList]);

  const handleUserSubmit = async (e) => {
    e.preventDefault();

    userData.oficinas = oficinasSeleccionadas.map((oficina) => ({
      id: oficina.id,
    }));

    try {
      if (userData.id_usuario) {
        console.log("Actualización", userData);
        await actualizarUsuario(userData);
        notification.success({
          message: "Usuario actualizado correctamente",
          description: `${userData.nombre} ha sido actualizado con éxito.`,
        });
      } else {
        console.log("Nuevo usuario", userData);
        await crearUsuario(userData);
        notification.success({
          message: "Usuario creado correctamente",
          description: `${userData.nombre} ha sido registrado exitosamente.`,
        });
      }

      setIsVisibleModal(false);
      setReload();
    } catch (error) {
      const mensaje = error?.message || "Ocurrió un error al guardar el usuario.";
      let userMessage = mensaje;

      if (
        mensaje.toLowerCase().includes("duplicate key") ||
        mensaje.toLowerCase().includes("email")
      ) {
        userMessage = "El email ya está en uso. Por favor ingresá otro.";
      }

      notification.error({
        message: "Error al guardar usuario",
        description: userMessage,
        duration: 6,
      });
    }
  };



  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;

    setUserData((prevState) => ({
      ...prevState,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const handleOficinasChange = (event, newValue) => {
    setOficinasSeleccionadas(newValue);
  };

  useEffect(() => {
    if (!window.google || !window.google.maps) {
      console.error("Google Maps JavaScript API script not loaded");
      return;
    }

    const autocomplete = new window.google.maps.places.Autocomplete(
      inputRef.current,
      {
        types: ["address"],
      }
    );

    autocomplete.addListener("place_changed", () => {
      const place = autocomplete.getPlace();
      if (place && place.address_components) {
        const addressComponents = place.address_components;
        const locality =
          addressComponents.find((comp) => comp.types.includes("locality"))
            ?.long_name || "";
        const province =
          addressComponents.find((comp) =>
            comp.types.includes("administrative_area_level_1")
          )?.long_name || "";
        const street =
          addressComponents.find((comp) => comp.types.includes("route"))
            ?.long_name || "";
        const streetNumber =
          addressComponents.find((comp) => comp.types.includes("street_number"))
            ?.long_name || "";
        setUserData((prevState) => ({
          ...prevState, // Conserva el estado anterior
          ext_domicilio: `${street} ${streetNumber}`.trim(),
          ext_localidad: locality,
          ext_provincia: province,
        }));
      }
    });

    autocompleteRef.current = autocomplete;
  }, []);

  if (loadingUsuario) {
    return <Loader />; // Puedes usar un spinner o cualquier componente de carga que prefieras
  }

  return (
    <form onSubmit={handleUserSubmit}>
      <Tabs value={tabIndex} onChange={handleTabChange}>
        {!onlyDocuments && <Tab label="Datos principales" />}
        {usuarioExistente && <Tab label="Documentos" />}
      </Tabs>

      <Box p={3} hidden={tabIndex !== 0}>
        <Grid container spacing={3}>
          <Grid item xs={12} sm={!usuarioExistente ? 4 : 6}>
            <TextField
              label="Nombre"
              name="nombre"
              size="small"
              value={userData.nombre}
              onChange={handleChange}
              fullWidth
            />
          </Grid>

          <Grid item xs={12} sm={!usuarioExistente ? 4 : 6}>
            <TextField
              label="Email"
              name="mail"
              size="small"
              value={userData.mail}
              onChange={handleChange}
              fullWidth
            />
          </Grid>
          {!usuarioExistente && (
            <Grid item xs={12} sm={4}>
              <TextField
                label="Contraseña *"
                name="password"
                size="small"
                value={userData.password}
                onChange={handleChange}
                fullWidth
              />
            </Grid>
          )}

          <Grid item xs={12} sm={4}>
            <TextField
              label="Tipo de Usuario"
              name="id_tipo_us"
              size="small"
              value={userData.id_tipo_us}
              onChange={(e) => {
                if (!usuarioExistente) {
                  setOficinasSeleccionadas([]);
                }
                handleChange(e);
              }}
              fullWidth
              select
              SelectProps={{ native: true }}
              InputLabelProps={{ shrink: true }}
            >
              <option value="0">Interno</option>
              <option value="1">Profesional</option>
              <option value="2">Particular</option>
            </TextField>
          </Grid>

          <Grid item xs={12} sm={6}>
            <TextField
              label="Profesión"
              name="ext_profesion"
              size="small"
              value={userData.ext_profesion}
              onChange={handleChange}
              fullWidth
            />
          </Grid>

          <Grid item xs={12} sm={6}>
            <TextField
              label="CUIT"
              name="ext_cuit"
              size="small"
              value={userData.ext_cuit}
              onChange={handleChange}
              fullWidth
            />
          </Grid>

          <Grid item xs={12} sm={6}>
            <TextField
              label="Razón Social"
              name="ext_razon_social"
              size="small"
              value={userData.ext_razon_social}
              onChange={handleChange}
              fullWidth
            />
          </Grid>

          <Grid item xs={12} sm={6}>
            <TextField
              label="Teléfono"
              name="ext_telefono"
              size="small"
              value={userData.ext_telefono}
              onChange={handleChange}
              fullWidth
            />
          </Grid>

          <Grid item xs={12} sm={6}>
            <FormControlLabel
              control={
                <Switch
                  checked={userData?.ext_homologado}
                  onChange={handleChange}
                  size="small"
                  name="ext_homologado"
                />
              }
              label="Homologado"
            />
          </Grid>

          <Grid item xs={12} sm={6}>
            <TextField
              label="Matrícula"
              name="ext_matricula"
              size="small"
              value={userData.ext_matricula}
              onChange={handleChange}
              fullWidth
            />
          </Grid>

          <Grid item xs={12} sm={6}>
            <TextField
              inputRef={inputRef} // Vinculado a Autocomplete
              label="Domicilio"
              name="ext_domicilio"
              size="small"
              value={userData.ext_domicilio}
              onChange={handleChange}
              fullWidth
            />
          </Grid>

          <Grid item xs={12} sm={6}>
            <TextField
              label="Localidad"
              name="ext_localidad"
              size="small"
              value={userData.ext_localidad}
              InputLabelProps={{ shrink: true }}
              disabled
              onChange={handleChange}
              fullWidth
            />
          </Grid>

          <Grid item xs={12} sm={6}>
            <TextField
              label="Provincia"
              name="ext_provincia"
              size="small"
              value={userData.ext_provincia}
              InputLabelProps={{ shrink: true }}
              disabled
              onChange={handleChange}
              fullWidth
            />
          </Grid>

          <Grid item xs={12} sm={6}>
            <TextField
              label="Número de Profesional"
              name="nro_prof"
              size="small"
              value={userData.nro_prof}
              onChange={handleChange}
              fullWidth
            />
          </Grid>

          {Number(userData?.id_tipo_us) === 0 && (
            <Grid item xs={12} sm={6}>
              <Autocomplete
                multiple
                size="small"
                id="tags-filled"
                options={oficinasList}
                filterSelectedOptions
                getOptionLabel={(option) => option.nombre}
                value={oficinasSeleccionadas || []}
                onChange={handleOficinasChange}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Oficinas"
                    placeholder="Seleccione a la/s oficinas que pertenece"
                  />
                )}
              />
            </Grid>
          )}

          <Grid item xs={12}>
            <Button type="submit" variant="contained" color="primary">
              {usuarioExistente ? "Actualizar" : "Crear"} Usuario
            </Button>
          </Grid>
        </Grid>
      </Box>
      <Box p={3} hidden={tabIndex !== 1} style={{ padding: "5px" }}>
        <Grid
          container
          direction="column"
          justifyContent="flex-start" // Cambiar a flex-start
          alignItems="stretch" // Cambiar a stretch
          style={{
            height: "52vh", // Mantener la altura
            width: "100%", // Asegurar que el contenedor ocupe el 100% del ancho
          }}
        >
          <Grid
            item
            xs={12}
            style={{
              maxWidth: "100%", // Asegura que no se exceda el ancho del contenedor
              flexGrow: 1, // Permitir que este Grid crezca para llenar el espacio
            }}
          >
            <DocumentosDeUsuario
              idUsuario={usuarioExistente ? usuarioExistente : null}
              setReload={setReload}
              reload={reload}
            />
          </Grid>
        </Grid>
      </Box>
    </form>
  );
};

export default UsuariosForm;
